import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { CommonState } from './types';
import { RootState } from '../RootState';

const state: CommonState = {
  locations: [],
};

export const CommonModule: Module<CommonState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
